<div class="st-drawer-wrapper">
  <a href=""></a>
  <!--  Header  -->
  <div class="st-drawer-header">
    <span class="text-header-18 text-semibold">{{ isUpdating ? 'Modificar contacto' : 'Añadir contactos' }}</span>
    <app-st-icon (click)="close()" class="text-header-16 cursor-pointer" [name]="'close'" [bold]="true"></app-st-icon>
  </div>

  <!--  Content  -->
  <div *ngIf="formIsFinish" class="st-drawer-content">
    <form class="st-form" nz-form [formGroup]="partnerForm">

      <!-- Avatar Section -->
      <div class="avatar-section">
        <nz-form-item>
          <nz-form-label [nzSpan]="24">Avatar</nz-form-label>
          <nz-form-control>
            <input type="hidden" nz-input formControlName="avatar"/>
            <div class="avatar-upload-container">
              <nz-upload #uploadComponent
                         class="avatar-upload"
                         [nzShowUploadList]="false"
                         [nzMultiple]="false"
                         [nzCustomRequest]="customUpload"
                         (nzChange)="handleUploadChange($event)"
                         nzAccept="image/*">
                <div class="avatar-content">
                  @if (avatarUrl) {
                    <img [src]="avatarUrl" class="avatar-image" alt="Avatar"/>
                  } @else {
                    <app-st-icon class="avatar-placeholder" [name]="'person'" [bold]="true"></app-st-icon>
                  }
                  <div class="avatar-overlay">
                    <span>{{ isUpdating ? 'Actualizar avatar' : 'Añadir avatar' }}</span>
                  </div>
                </div>
              </nz-upload>
            </div>
          </nz-form-control>
        </nz-form-item>
      </div>

      <!-- Company/Employee Section -->
      <div class="checkbox-section" nz-row [nzGutter]="16">
        <div nz-col [nzXs]="12">
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Empresa</nz-form-label>
            <nz-form-control>
              <label nz-checkbox formControlName="isCompany">Es empresa</label>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col [nzXs]="12">
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Empleado</nz-form-label>
            <nz-form-control>
              <label nz-checkbox formControlName="employee">Es empleado</label>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>

      <!-- Active/BlackListed Section -->
      <div class="checkbox-section" nz-row [nzGutter]="16">
        <div nz-col [nzXs]="12">
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Está activo</nz-form-label>
            <nz-form-control>
              <label nz-checkbox formControlName="isActive">Está Activo</label>
            </nz-form-control>
          </nz-form-item>
        </div>
        <!--        <div nz-col [nzXs]="12">-->
        <!--          <nz-form-item [hidden]="!this.nzData.editingElement">-->
        <!--            <nz-form-label [nzSpan]="24">En lista negra</nz-form-label>-->
        <!--            <nz-form-control>-->
        <!--              <label nz-checkbox formControlName="isBlacklisted">En lista negra</label>-->
        <!--            </nz-form-control>-->
        <!--          </nz-form-item>-->
        <!--        </div>-->
      </div>

      <!-- Name Section -->
      <div nz-row [nzGutter]="16">
        <div nz-col [nzXs]="24">
          <nz-form-item>
            <nz-form-label [nzSpan]="24" nzRequired>Nombre y Apellidos</nz-form-label>
            <nz-form-control [nzErrorTip]="'Este campo es requerido'">
              <input type="text" nzSize="large" nz-input formControlName="name"
                     placeholder="Introduce Nombre y Apellidos..."/>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>

      <!-- Type of Contact and Position -->
      <div nz-row [nzGutter]="16">
        <div nz-col [nzXs]="24" [nzSm]="12">
          <nz-form-item>
            <nz-form-label [nzSpan]="24" nzRequired>Tipo de contacto</nz-form-label>
            <nz-form-control [nzErrorTip]="'Este campo es requerido'">
              <nz-select [nzSuffixIcon]="customSelectIcon" nzSize="large"
                         formControlName="partnerTypeId" nzPlaceHolder="Selecciona Tipo de contacto...">
                <nz-option *ngFor="let type of nzData.columnsData[4].optionList" [nzLabel]="type.name"
                           [nzValue]="type.id"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col [nzXs]="24" [nzSm]="12">
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Cargo</nz-form-label>
            <nz-form-control>
              <input type="text" nzSize="large" nz-input formControlName="position"
                     placeholder="Introduce Cargo..."/>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>

      <!-- Related Company and State -->
      <div nz-row [nzGutter]="16">
        <div nz-col [nzXs]="24" [nzSm]="12">
          <nz-form-item *ngIf="existControlInForm('parentId')">
            <nz-form-label [nzSpan]="24">Empresa relacionada</nz-form-label>
            <nz-form-control>
              <app-avatar-select [formControlName]="'parentId'"
                                 [options]="getPartnerOptions(nzData.columnsData[6])"
                                 [placeholder]="'Selecciona Empresa relacionada...'"
              ></app-avatar-select>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col [nzXs]="24" [nzSm]="12">
          <nz-form-item>
            <nz-form-label [nzSpan]="24" nzRequired>Estado</nz-form-label>
            <nz-form-control [nzErrorTip]="'Este campo es requerido'">
              <nz-select [nzSuffixIcon]="customSelectIcon" nzSize="large"
                         formControlName="stateId" nzPlaceHolder="Selecciona Estado...">
                <nz-option *ngFor="let state of nzData.columnsData[7].optionList" [nzLabel]="state.name"
                           [nzValue]="state.id"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>

      <div nz-row [nzGutter]="16">
        <div nz-col [nzSpan]="24">
          <!-- Email -->
          <nz-form-item>
            <nz-form-label [nzSpan]="24" nzRequired>Email</nz-form-label>
            <nz-form-control [nzErrorTip]="emailErrorTpl">
              <input type="email" nzSize="large" nz-input formControlName="email"
                     placeholder="Introduce Email..." style="border-radius: 6px"/>
            </nz-form-control>
            <ng-template #emailErrorTpl>
              {{ getEmailValidationMessage(partnerForm.get('email')) }}
            </ng-template>
          </nz-form-item>
        </div>
      </div>
      <div nz-row [nzGutter]="16">
        <div nz-col [nzSpan]="24">
          <!-- Billing Email -->
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Email de facturación</nz-form-label>
            <nz-form-control [nzErrorTip]="billingEmailErrorTpl">
              <input type="email" nzSize="large" nz-input formControlName="billingEmail"
                     placeholder="Introduce Email para facturación..." style="border-radius: 6px"/>
            </nz-form-control>
            <ng-template #billingEmailErrorTpl>
              {{ getEmailValidationMessage(partnerForm.get('billingEmail')) }}
            </ng-template>
          </nz-form-item>
        </div>
      </div>

      <!-- VAT and IMO -->
      <div nz-row [nzGutter]="16">
        <div nz-col [nzXs]="24" [nzSm]="12">
          <nz-form-item>
            <nz-form-label [nzSpan]="24">VAT</nz-form-label>
            <nz-form-control>
              <input type="text" nzSize="large" nz-input formControlName="vat"
                     placeholder="Introduce VAT..."/>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col [nzXs]="24" [nzSm]="12">
          <!--          <nz-form-item>-->
          <!--            <nz-form-label [nzSpan]="24">IMO</nz-form-label>-->
          <!--            <nz-form-control>-->
          <!--              <label nz-checkbox formControlName="imo">Habilitado para cargas IMO</label>-->
          <!--            </nz-form-control>-->
          <!--          </nz-form-item>-->
        </div>
      </div>

      <!-- Notes -->
      <nz-form-item>
        <nz-form-label [nzSpan]="24">Notas</nz-form-label>
        <nz-form-control>
          <textarea nzSize="large" nz-input formControlName="comment"
                    placeholder="Introduce Notas..." [nzAutosize]="{ minRows: 3, maxRows: 5 }"></textarea>
        </nz-form-control>
      </nz-form-item>

      <!-- Collapsible sections -->
      <nz-collapse [nzBordered]="false" class="key-item-collapse medium-header-padding">
        <!-- Contact Data Section -->
        <nz-collapse-panel #contactData [nzShowArrow]="false" [nzHeader]="contactDataTmpl">
          <ng-template #contactDataTmpl>
            <app-collapse-panel-header [minHeight]="'0px'" [panelActive]="contactData.nzActive"
                                       [onlyText]="'Datos de contacto'">
            </app-collapse-panel-header>
          </ng-template>

          <!-- Phone and Mobile -->
          <div nz-row [nzGutter]="16">
            <div nz-col [nzXs]="24" [nzSm]="12">
              <nz-form-item>
                <nz-form-label [nzSpan]="24">Teléfono Móvil</nz-form-label>
                <nz-form-control>
                  <input type="text" nzSize="large" nz-input formControlName="mobile"
                         placeholder="Introduce Teléfono Móvil..."/>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col [nzXs]="24" [nzSm]="12">
              <nz-form-item>
                <nz-form-label [nzSpan]="24">Teléfono</nz-form-label>
                <nz-form-control>
                  <input type="text" nzSize="large" nz-input formControlName="phone"
                         placeholder="Introduce Teléfono..."/>
                </nz-form-control>
              </nz-form-item>
            </div>
          </div>

          <!-- Restricted Phone and Website -->
          <div nz-row [nzGutter]="16">
            <div nz-col [nzXs]="24" [nzSm]="12">
              <!-- <nz-form-item>
                <nz-form-label [nzSpan]="24">Teléfono restringido</nz-form-label>
                <nz-form-control>
                  <label nz-checkbox formControlName="restrictedPhone">Marcar teléfono como restringido</label>
                </nz-form-control>
              </nz-form-item> -->
            </div>
            <div nz-col [nzXs]="24" [nzSm]="12">
              <nz-form-item>
                <nz-form-label [nzSpan]="24">Web</nz-form-label>
                <nz-form-control [nzErrorTip]="'Este campo es requerido'">
                  <input type="text" nzSize="large" nz-input formControlName="website"
                         placeholder="Introduce Web..."/>
                </nz-form-control>
              </nz-form-item>
            </div>
          </div>
        </nz-collapse-panel>

        <!-- Address Section -->
        <nz-collapse-panel #address [nzShowArrow]="false" [nzHeader]="addressTmpl">
          <ng-template #addressTmpl>
            <app-collapse-panel-header [minHeight]="'0px'" [panelActive]="address.nzActive"
                                       [onlyText]="'Dirección'">
            </app-collapse-panel-header>
          </ng-template>

          <!-- Address and Additional Address -->
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Dirección</nz-form-label>
            <nz-form-control>
              <input type="text" nzSize="large" nz-input formControlName="street"
                     placeholder="Introduce Dirección..."/>
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label [nzSpan]="24">Dirección Adicional</nz-form-label>
            <nz-form-control>
              <input type="text" nzSize="large" nz-input formControlName="street2"
                     placeholder="Introduce Dirección Adicional..."/>
            </nz-form-control>
          </nz-form-item>

          <!-- City, Postal Code, and Country -->
          <div nz-row [nzGutter]="16">
            <div nz-col [nzXs]="24" [nzSm]="8">
              <nz-form-item>
                <nz-form-label [nzSpan]="24">Ciudad</nz-form-label>
                <nz-form-control [nzErrorTip]="'Este campo es requerido'">
                  <input type="text" nzSize="large" nz-input formControlName="city"
                         placeholder="Introduce Ciudad..."/>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col [nzXs]="24" [nzSm]="8">
              <nz-form-item>
                <nz-form-label [nzSpan]="24">Código Postal</nz-form-label>
                <nz-form-control [nzErrorTip]="'Este campo es requerido'">
                  <input type="text" nzSize="large" nz-input formControlName="zip"
                         placeholder="Introduce Código Postal..."/>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col [nzXs]="24" [nzSm]="8">
              <nz-form-item>
                <nz-form-label [nzSpan]="24">País</nz-form-label>
                <nz-form-control [nzErrorTip]="'Este campo es requerido'">
                  <nz-select [nzSuffixIcon]="customSelectIcon" nzSize="large"
                             formControlName="countryId" nzPlaceHolder="Selecciona País...">
                    <nz-option *ngFor="let country of getOptionList('countryId')" [nzLabel]="country.name"
                               [nzValue]="country.id"></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>
          </div>

          <!-- Latitude and Longitude -->
          <div nz-row [nzGutter]="16">
            <div nz-col [nzXs]="24" [nzSm]="12">
              <nz-form-item>
                <nz-form-label [nzSpan]="24">Latitud</nz-form-label>
                <nz-form-control>
                  <input type="text" nzSize="large" nz-input formControlName="latitude"
                         placeholder="Introduce Latitud..."/>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col [nzXs]="24" [nzSm]="12">
              <nz-form-item>
                <nz-form-label [nzSpan]="24">Longitud</nz-form-label>
                <nz-form-control>
                  <input type="text" nzSize="large" nz-input formControlName="longitude"
                         placeholder="Introduce Longitud..."/>
                </nz-form-control>
              </nz-form-item>
            </div>
          </div>

          <!-- Currency -->
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Divisa</nz-form-label>
            <nz-form-control [nzErrorTip]="'Este campo es requerido'">
              <nz-select [nzSuffixIcon]="customSelectIcon" nzSize="large"
                         formControlName="currencyId" nzPlaceHolder="Selecciona Divisa..."
                         [nzDisabled]="!partnerForm.get('isCompany')?.value">
                <nz-option *ngFor="let currency of getOptionList('currencyId')" [nzLabel]="currency.name"
                           [nzValue]="currency.id"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </nz-collapse-panel>

        <!-- Documentation Section -->
        <nz-collapse-panel #documentation [nzShowArrow]="false" [nzHeader]="documentationTmpl">
          <ng-template #documentationTmpl>
            <app-collapse-panel-header [minHeight]="'0px'" [panelActive]="documentation.nzActive"
                                       [onlyText]="'Documentación'">
            </app-collapse-panel-header>
          </ng-template>

          <div class="document-upload-container">
            <div class="upload-zone"
                 (dragover)="onDragOver($event)"
                 (dragleave)="onDragLeave($event)"
                 (drop)="onFileDrop($event)"
                 (click)="fileInput.click()">
              <app-st-icon [name]="'upload'" [bold]="true"></app-st-icon>
              <p>Arrastra a esta ventana o haz click para subir documentos.</p>
              <input #fileInput type="file" style="display: none" multiple (change)="onFileSelected($event)">
            </div>

            <div *ngIf="uploadedDocuments.length > 0" class="document-list">
              <div *ngFor="let doc of uploadedDocuments; let i = index" class="document-item">
                <app-st-icon [name]="'description'" [bold]="true"></app-st-icon>
                <div class="document-info">
                  <span class="doc-name">{{ doc.name }}</span>
                  <span class="doc-size">{{ doc.size }}</span>
                  <div *ngIf="doc.progress > 0 && doc.progress < 100" class="progress-bar">
                    <div class="progress" [style.width.%]="doc.progress"></div>
                  </div>
                </div>

                <nz-date-picker class="expiration-date-picker" nzSize="large"
                                style="max-width: 150px; margin-right: 15px"
                                (ngModelChange)="expirationDateChange($event, doc)"
                                [formControl]="getDocumentFormControl(i, 'expirationDate')"></nz-date-picker>

                <nz-select style="max-width: 200px" [nzSuffixIcon]="customSelectIcon" nzSize="large"
                           [formControl]="getDocumentFormControl(i, 'documentTypeId')"
                           (ngModelChange)="onDocumentTypeChange($event, doc)"
                           nzPlaceHolder="Tipo documento..." class="document-type-select" nzRequired>
                  <nz-option *ngFor="let docType of documentsColumn?.optionList || documentTypesList"
                             [nzLabel]="docType.name"
                             [nzValue]="docType.id">
                  </nz-option>
                </nz-select>
                <app-st-icon (click)="removeDocument(i)" class="delete-icon" [name]="'delete'"
                             [bold]="true"></app-st-icon>
              </div>
            </div>
          </div>
        </nz-collapse-panel>
      </nz-collapse>

      <!--
        Empleados asociados (CEC-334). Solo al EDITAR una empresa ya existente:
        en el alta todavia no hay id al que asociar los empleados.
        La asociacion se escribe sobre el contacto hijo via PartnerService, no
        a traves de partnerForm, asi que no interfiere con el guardado de la empresa.
      -->
      <app-company-employees *ngIf="partnerForm.get('isCompany')?.value && nzData.editingElement?.id"
                             [companyId]="nzData.editingElement!.id"
                             [companyName]="nzData.editingElement!.name"
                             [editable]="true"></app-company-employees>
    </form>
  </div>

  <!--  Footer  -->
  <div class="st-drawer-footer">
    <button (click)="close()" class="text-btn-14" nz-button nzType="text" nzShape="round" nzSize="large">Cancelar
    </button>

    <div class="flex gap-200">
      <button *ngIf="!isUpdating" [disabled]="!partnerForm.valid || !allDocumentsHaveValidTypes()"
              (click)="savePartner(false)"
              class="text-btn-14" nz-button nzType="default" nzShape="round" nzSize="large">
        <app-st-icon *ngIf="savingPartner" class="prefix" [name]="'progress_activity'" [bold]="true"></app-st-icon>
        <span>Añadir y seguir añadiendo</span>
      </button>

      <button (click)="savePartner(true)" [disabled]="!partnerForm.valid || !allDocumentsHaveValidTypes()"
              class="text-btn-14" nz-button nzType="primary" nzShape="round" nzSize="large">
        <app-st-icon *ngIf="!savingPartner" class="prefix" [name]="isUpdating ? 'update' : 'add'"
                     [bold]="true"></app-st-icon>
        <app-st-icon *ngIf="savingPartner" class="prefix" [name]="'progress_activity'" [bold]="true"></app-st-icon>
        <span>{{ isUpdating ? 'Guardar contacto' : 'Añadir contacto' }}</span>
      </button>
    </div>
  </div>
</div>

<ng-template #customSelectIcon>
  <app-st-icon class="custom-suffix" name="keyboard_arrow_down"></app-st-icon>
</ng-template>

<ng-template #customClearIcon>
  <app-st-icon class="custom-clear" name="close"></app-st-icon>
</ng-template>

<!--  Notification  -->
<ng-template #notificationTmpl>
  <app-toast *ngIf="notRef" [icon]="toastConfig.icon" [iconColor]="toastConfig.iconColor"
             [showUndo]="toastConfig.showUndo"
             [notRef]="notRef" [content]="toastConfig.content" [msg]="toastConfig.msg"></app-toast>
</ng-template>
